import React, { memo } from 'react';
import { InfoOutline } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4 } from '@yme/tokens/typography';
function DisclaimerTextComponent({ disclaimerText, colorText = colorCoreWhite1000, }) {
    return (React.createElement(FlexWrapper, { gap: "8px", alignItems: "flex-start" },
        React.createElement(SVGIcon, { pathFill: colorText, type: InfoOutline, size: ICON_SIZE.xs }),
        React.createElement(RegularTextLevel4, { color: colorText }, disclaimerText)));
}
export const DisclaimerText = memo(DisclaimerTextComponent);
DisclaimerText.displayName = 'DisclaimerText_Atom';
